import { DropdownOption } from "@/types";

export const getOptionLabel = (option: DropdownOption | string) => {
  if (typeof option === "string") {
    return option;
  }
  return option.label;
};
